import getConfig from 'next/config'
import {
  SECURITY_NOTICE_BY_BRAND,
  SecurityNoticeConfig,
} from 'src/constants/securityNotice'

const DAY_MS = 86_400_000

/**
 * Security notice resolver.
 *
 * The brand is fixed at build time (one image per brand) and surfaced via
 * `publicRuntimeConfig.brandName` (env `BRAND_NAME`), read exactly as
 * `isPaylinka()` reads it.
 *
 * Not Redux `(state) => ...` selectors: brandName never changes at runtime,
 * so these are plain functions safe to call in components and SSR.
 * `getConfig()` returns undefined outside the Next runtime, hence the guard.
 * It is called on every call, with no module-level cache.
 */
export const getSecurityNoticeConfig = (): SecurityNoticeConfig | undefined => {
  const brandName: string | undefined =
    getConfig()?.publicRuntimeConfig?.brandName

  return brandName ? SECURITY_NOTICE_BY_BRAND[brandName] : undefined
}

/**
 * Decides whether the notice has to be shown again.
 *
 * Pure on purpose: the stored mark, the current time and the interval are
 * passed in. A missing or unparseable mark fails toward showing the notice.
 */
export const isSecurityNoticeDue = (
  dismissedAt: string | null,
  now: Date,
  intervalDays: number
): boolean => {
  if (!dismissedAt) {
    return true
  }

  const parsed = Date.parse(dismissedAt)

  if (Number.isNaN(parsed)) {
    return true
  }

  return now.getTime() - parsed >= intervalDays * DAY_MS
}
